import request from '../../utils/request'


// 获取租户个性化配置列表
export function getPersonalization(query) {
    return request({
        url: '/system/tenant/personalizationDetail',
        method: 'get',
        params: query
    })
}

